import { Injectable } from '@angular/core';
import { AppGlobalsServiceBase } from 'scaletech-core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppGlobalsService extends AppGlobalsServiceBase {

  private _versionBeta: boolean = environment.testMode;
  private _versionSuffix = (this._versionBeta ? 'beta - ' : ' - ') + environment.packageDate;
  private _version: string = environment.VERSION;
  protected _timeZone = 'EDT';
  public get appVersion(): string { return this._version = `v. ${this._version} ${this._versionSuffix}`; }

  constructor() {
    super();
  }
}
